import { Box, MenuItem } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { Card, Col, Dropdown, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/**API */
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import { getBranch } from 'utils/app.utils'

/**COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'
import FilterSelect from 'component/Select/FilterSelect'

/**STYLE */
import ComponentApi from 'api/components-api'
import ButtonCustom from 'component/Button/ButtonCustom'
import SearchPatients from 'component/SearchPatients'
import * as UseStyled from 'features/report/useStyled'
import AccountingCodeList from './AccountingCodeList'

type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}

export interface DentistInterface {
  dentistId: number
  dentistFullname: string
}

export default function AccountingCode() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange
  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [operativeCode, setOperativeCode] = useState<any[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [fetch, setFetch] = useState(false)
  const [rows, setRows] = useState<any[]>([])
  const [rowsExport, setRowsExport] = useState<any[]>([])
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
  const [page, setPage] = useState<number>(1)
  const [pageLimit, setPageLimit] = useState<number>(10)
  const [loading, setLoading] = useState<boolean>(true)
  const [selectDoctors, setSelectDoctors] = useState<any[]>([])
  const [billStatus, setBillStatus] = useState<string>('ALL')
  const [patientFilter, setPatientFilter] = useState<string>(t('REPORT.REPORT_GROUP.ALL'))
  const [patientId, setPatientId] = useState<number>(0)
  const [codeForm, setCodeForm] = useState<{ operativeCode: string }>({ operativeCode: '' })
  const [codeTo, setCodeTo] = useState<{ operativeCode: string }>({ operativeCode: '' })
  const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const handleFilterDoctors = (value: any) => {
    if ((value === 'ALL' && _.size(selectDoctors.filter((item) => typeof item === 'number')) === _.size(doctors)) || value === 'CLEAR') setSelectDoctors([''])
    else if (value === 'ALL') setSelectDoctors(['ALL', ..._.map(doctors, (d: any) => d.userId)])
    else if (_.includes(selectDoctors, value)) setSelectDoctors(_.filter(selectDoctors, (d) => d !== value && d !== 'ALL'))
    else setSelectDoctors([...selectDoctors, value])
  }

  const getFilterUser = () => {
    if (_.includes(selectDoctors, 'ALL')) return ` ${t('REPORT.REPORT_GROUP.ALL')}`
    else {
      return ` ${doctorsMultiple
        .filter((d: DentistInterface) => selectDoctors.includes(d.dentistId))
        ?.map((d: DentistInterface) => d.dentistFullname)
        .join(', ')}`
    }
  }

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    // ReportApi.reportList(condition).then(({ data }) => {
    //   const check = _.find(data, (val: any) => String(val.reportKey) === 'DF_LAB') ? true : false
    //   if (!check) {
    //     history.push(routeName.report)
    //     return false
    //   }
    // })

    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })
    ComponentApi.findAllOperativeCode()
      .then(({ data }) => setOperativeCode(data))
      .catch((e) => {
        return
      })
    ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1])
      .then((resp) => {
        setDoctors([...resp.data])
        setSelectDoctors(['ALL', ...resp.data.map((d: any) => d.userId)])
      })
      .catch((e) => {
        return
      })

    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [branchId])

  const fetchDF = useCallback(async () => {
    let condition: any = {
      page: page,
      pageLimit: pageLimit,
      branchId: branchId,
      patientId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      billStatus: billStatus === 'ALL' ? '' : billStatus
    }
    if (selectDoctors.length) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (selectDoctors[0] !== "ALL" && doctor) condition = { ...condition, doctorId: doctor }
    }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }

    ReportApi.reportAccountingCode(condition)
      .then(({ headers, data }) => {
        setRows(data.rows)
      })
    //   .catch((e) => setLoading(false))
    //   .finally(() => {
    //     setLoading(false)
    //   })
    // setFetch(false)
  }, [page, pageLimit, sortBy, sortType, fetch])
  const fetchDFExport = useCallback(async () => {
    let condition: any = {
      page: page,
      pageLimit: pageLimit,
      branchId: branchId,
      patientId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      billStatus: billStatus === 'ALL' ? '' : billStatus,
      export: 1
    }
    if (selectDoctors.length) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (selectDoctors[0] !== "ALL" && doctor) condition = { ...condition, doctorId: doctor }
    }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }

    ReportApi.reportAccountingCode(condition)
      .then(({ headers, data }) => {
        setRowsExport(data.rows)
        setRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => {
        setLoading(false)
      })
    setFetch(false)
  }, [page, pageLimit, sortBy, sortType, fetch])

  const { onDownload } = useDownloadExcel({
    tableExportRef: componentRef.current,
    filename: `${t(`REPORT.REPORT_NAME.ACCOUNTING_CODE`)}`,
    sheetName: `${t(`REPORT.REPORT_NAME.ACCOUNTING_CODE`)}`
  })

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

  const handleChangePage = (val: number) => setPage(val)

  useEffect(() => {
    fetchDF()
  }, [fetchDF])
  useEffect(() => {
    fetchDFExport()
  }, [fetchDFExport])


  const handleClear = () => setPatientId(0)

  return (
    <>
      <Card className={'border-0 h-100'}>
        <HeaderCard text={t(`Accounting Code Report`)} />
        <Card.Body>
          <Card.Title className={'mb-0'}>
            <Row className="mx-0">
              <Col sm={6} md={4} xl={3} className={'pt-2 px-1'}>
                <InputSecondNewRangePicker
                  inputHeight={32}
                  value={rangeDate || emptyRangePicker}
                  onchange={(val: any) => {
                    if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                    else setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                  }}
                  label={''}
                  allowClear
                  onClear={() => setRangeDate(emptyRangePicker)}
                />
              </Col>
              <Col sm={6} md={4} xl={4} className={'pt-2 px-1'}>
                <SearchPatients
                  status="ACTIVE"
                  callbackPatientId={setPatientId}
                  patientId={patientId}
                  onClear={handleClear}
                  callbackPatientName={(value) => {
                    setPatientFilter(value)
                  }}
                />
              </Col>
              <Col sm={6} md={4} xl={3} className={'pt-2 px-1'}>
                <FilterSelect
                  onchange={(e) => {
                    setBillStatus(e.target.value)
                    setPage(1)
                  }}
                  renderValue={() => `${t('REPORT.FILTER.RECEIPT_STATUS')}: ${billStatus === 'ALL' ? t(`REPORT.FILTER.ALL`) : t(`REPORT.FILTER.BILL.${billStatus}`)} `}
                  label={''}
                  selectId="select-bill-status"
                  labelId="label-bill-status"
                  value={billStatus}
                  options={[
                    <MenuItem key="1" value="ALL">
                      {t('REPORT.FILTER.ALL')}
                    </MenuItem>,
                    <MenuItem key="2" value="PAID">
                      {t('REPORT.FILTER.BILL.PAID')}
                    </MenuItem>,
                    <MenuItem key="3" value="CANCEL">
                      {t('REPORT.FILTER.BILL.CANCEL')}
                    </MenuItem>
                  ]}
                  formControlStyle={{ maxWidth: 'unset !important' }}
                  classesOption="style-select-doctors"
                />
              </Col>
              <Col md={1} xl={1} className={'pt-0'}>
                <ButtonCustom
                  onClick={() => {
                    setFetch(true)
                    setPage(1)
                    setLoading(true)
                  }}
                  textButton={t('INPUT.SEARCH')}
                  style={{ height: '30px', marginTop: '5px' }}
                />
              </Col>

              <Col md={4} xl={2} className={'d-xl-flex justify-content-xl-end ml-xl-auto'}>
                <UseStyled.DropdownDocument>
                  <Dropdown.Toggle id="dropdown-basic" className="ml-xl-auto">
                    {t('REGISTER.BUTTON.PRINT_DOCUMENT')}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={onDownload}>{t('Excel')}</Dropdown.Item>
                    {/* <FucntionPrint
                      content={() => componentRef.current}
                      removeIfram
                      trigger={() => <Dropdown.Item>{t('PDF')}</Dropdown.Item>}
                      style={`@page { size: 793.7007874px 1122.519685px;  margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }`}
                    /> */}
                  </Dropdown.Menu>
                </UseStyled.DropdownDocument>
              </Col>
            </Row>
          </Card.Title>
          <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
            <AccountingCodeList
              page={page}
              pageLimit={pageLimit}
              rowCount={rowCount}
              sortBy={sortBy}
              sortType={sortType}
              data={rows}
              dataExport={rowsExport}
              onRequestSort={onRequestSort}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleChangePage={handleChangePage}
              setSortType={setSortType}
              setSortBy={setSortBy}
              componentRef={componentRef}
            />
          </Box>
        </Card.Body>
        <Loading show={loading} type="fullLoading" />
      </Card>
    </>
  )
}
